import { useContext, useRef } from "react";
import Form from "react-bootstrap/Form";
import { Formik, FormikProps } from "formik";
import * as Yup from "yup";
import { Container } from "reactstrap";

//Common
import { TextField, Autocomplete, Chip } from "../../common/VFX-UI";

import ActionBar from "../../common/ActionBar/ActionBar";
import FormBackGround from "../../common/Forms/FormBackGround/FormBackGround";
import FormHeader from "../../common/Forms/FormHeader/FormHeader";

//App
import { ClaimContext } from "./ClaimContainer";
import { ClaimContextData, ClaimFormProps } from "../../../types/claim";
import { EMPTY_GUID } from "../../../utility/constants/constants";

const validationSchema = Yup.object().shape({
  name: Yup.string().required("Name is required"),
  description: Yup.string().required("Description is required"),
  claimTypeId: Yup.array()
    .min(1, "Claim Type is required")
    .required("Claim Type is required"),
  sortValue: Yup.number().min(0, "Must be positive number"),
});

const ClaimForm = (props: ClaimFormProps) => {
  const { status, initialVal, onClose, handleOnSubmit } = props;
  const formRef = useRef<FormikProps<any>>(null);

  const { id, claimTypeId } = initialVal;
  const title = id === EMPTY_GUID ? "New Claim" : "Edit Claim";

  const claimContext = useContext<ClaimContextData | null>(ClaimContext);

  const saveInput = () => {
    if (formRef.current) {
      formRef.current.handleSubmit();
    }
  };

  return (
    <FormBackGround>
      <FormHeader title={title} onClose={onClose} />
      <Formik
        onSubmit={handleOnSubmit}
        initialValues={initialVal}
        validationSchema={validationSchema}
        innerRef={formRef}
      >
        {({ values })  => (
          <Container>
            <Form noValidate>
              <div className="d-flex justify-content-end mb-3 me-3">
                <Chip label={values.isActive ? "Active" : "Inactive"} />
              </div>
              <TextField
                label="Name"
                type="text"
                name="name"
                isRequired={true}
              />
              <TextField
                label="Description"
                type="textarea"
                name="description"
                isRequired={true}
              />
              <Autocomplete
                disabled={true}
                name="claimTypeId"
                label="Claim Type"
                isRequired={true}
                options={claimContext?.claimTypes ?? []}
                defaultSelected={
                  claimTypeId != null && claimTypeId.length > 0
                    ? [claimTypeId[0]]
                    : []
                }
              />
              <TextField label="Display Order" type="number" name="sortValue" />
              <ActionBar
                submitHandler={saveInput}
                cancelHandler={onClose}
                submitText="Submit"
                cancelText="Cancel"
                isLoading={status === "pending"}
              ></ActionBar>
            </Form>
          </Container>
        )}
      </Formik>
    </FormBackGround>
  );
};

export default ClaimForm;
